module.exports = __webpack_public_path__ + "img/mg.b8f37dd2.png";